import { apiManager } from "../api-manager";

export const approveOrRejectResubmittedDocuments = async (
  id: string,
  isApproved: boolean,
  reason?: string
) => {
  const body: {
    isApproved: boolean;
    rejectReason?: string;
  } = {
    isApproved,
  };

  if (!isApproved && reason) {
    body.rejectReason = reason;
  }

  const res = await apiManager.patch(`/admin/resubmit/${id}/modify`, body);
  return res;
};
